// ./router/index.js

import VueRouter from 'vue-router'

//HBBox
//import home from '@/views/hbbox.de/home.vue'
//Enwatmon
import home from '@/views/home.vue'


import mainViewVue from '@/views/main-view.vue'


import maschines from '@/views/maschines.vue'
import my_maschine from '@/views/my_maschine.vue'
import loginViaUrlVue from '@/views/login-via-url.vue'
import settingsRouter from './settingsRouter.js'

import changePasswordDialog from '@/views/dialog-views/change-password-dialog.vue'

import myMaschineOverview from '@/views/myMaschine/maschine-overview.vue'
import kategoriesView from '@/views/myMaschine/kategorie-view.vue'

import messageFrameDialog from '@/views/dialog-views/message-frame-dialog.vue'

import messagingDialog from '@/views/dialog-views/push-manager-dialog.vue'
import globalViewRouter from './globalViewRouter.js'

export default new VueRouter({
  mode:'history',
  routes: [
    { path: '/', component: home },
    { name: 'maschines', path: '/maschines', component: maschines, },
    { path: '/login-via-url/:token', component: loginViaUrlVue, props: true, },
    
    { name: 'change-user-settings', path: '/change-user-settings', component: changePasswordDialog, },
    {
      name: 'main', path: '/main', component: mainViewVue, redirect: { name: 'main-global-view'},  children: [
        globalViewRouter,
        settingsRouter,

        {
          name: 'my_maschine', path: '/my_maschine/:id/:name/', redirect: { name: 'maschine-overview-view'},  component: my_maschine, props: true, children: [
            { name: 'maschines', path: '/my_maschine/:id/:name/maschines', component: maschines, },

            { name: 'maschine-overview-view', path: '/my_maschine/:id/:name/overview', props: true, component: myMaschineOverview, },
            { name: 'kategorie-view', path: '/my_maschine/:id/:name/:kid/:kategorie', props: true, component: kategoriesView,
              children: [
                { name: 'message-frame-dialog', path: '/my_maschine/:id/:name/:kid/:kategorie/:IDh_chart/message-frame-dialog', props: true, component: messageFrameDialog, }
              ]
            },

            

          ]
        },
        

        { name: 'messaging-dialog', path: '/messaging', component: messagingDialog, },

      ]

    },
  
    { path: '*', template: '<p>404</P>' } // Not found
  ]
})